import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["large", "small", "avatarSize"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react'; // @ts-expect-error

import { PropTypes } from 'proper-types';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { useAnimationControl } from '@bubble-ui/provider-animation-control';
import { getDefaultStyleSheet, getKeyframes } from './utils';

var Loader = function Loader(_ref) {
  var large = _ref.large,
      small = _ref.small,
      avatarSize = _ref.avatarSize,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useAnimationControl = useAnimationControl(),
      disableAnimations = _useAnimationControl.disableAnimations;

  var animationStyle = getKeyframes({
    small: small,
    large: large,
    avatarSize: avatarSize
  });
  var designVersion = useDesignVersion();

  var _useStyleSheet = useStyleSheet(Loader, getDefaultStyleSheet, _objectSpread({
    designVersion: designVersion,
    small: small,
    large: large,
    avatarSize: avatarSize,
    disableAnimations: disableAnimations
  }, props)),
      svgAttrs = _useStyleSheet.svgAttrs,
      svgStyle = _useStyleSheet.svgStyle,
      circleAttrs = _useStyleSheet.circleAttrs,
      circleStyle = _useStyleSheet.circleStyle;

  return /*#__PURE__*/React.createElement("svg", _extends({}, svgAttrs, {
    style: svgStyle
  }), !disableAnimations && /*#__PURE__*/React.createElement("style", null, animationStyle), /*#__PURE__*/React.createElement("circle", _extends({}, circleAttrs, {
    style: circleStyle
  })));
};

Loader.displayName = 'Loader';
var OverridableLoader = withProvisionalOverrideFromContext(Loader); // @ts-expect-error

OverridableLoader.properTypes = {
  inverted: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool,
  avatarSize: PropTypes.oneOf(['small', 'medium', 'regular', 'large'])
};
export default OverridableLoader;
//# sourceMappingURL=index.js.map